(() => {
  'use strict';

  function initFaqAccordion() {
    const accordions = document.querySelectorAll('.acci-faqs__accordion-item');
    
    accordions.forEach((item) => {
      const trigger = item.querySelector('.acci-faqs__accordion-trigger');
      const content = item.querySelector('.acci-faqs__accordion-content');
      
      if (!trigger || !content) return;
      
      // Prevent multiple listeners if re-initialized
      if (trigger.dataset.initialized) return;
      trigger.dataset.initialized = 'true';
      
      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        
        if (isOpen) {
          trigger.setAttribute('aria-expanded', 'false');
          content.hidden = true;
          item.classList.remove('is-active');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          content.hidden = false;
          item.classList.add('is-active');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }

  document.addEventListener('shopify:section:load', initFaqAccordion);
  document.addEventListener('shopify:block:select', initFaqAccordion);
  document.addEventListener('shopify:block:deselect', initFaqAccordion);
})();